/* eslint-disable react/destructuring-assignment */
import { MD5 } from 'crypto-js';
import React, { useState } from 'react';
import { DownArrowIcon } from '../../../utils/SVGIcon';
import cn from '../../../utils/cn';

function ItemArr({ data }) {
    return (
        <li
            className={cn(
                'flex justify-start items-center gap-2.5 border border-[#61AFFE] bg-[#61AFFE]/20 p-[5px] rounded-[4px] my-1.5',
                {
                    'border-[#61AFFE] bg-[#61AFFE]/20': data.httpMethod.toUpperCase() === 'GET',
                    'border-[#49cc90] bg-[#49cc90]/20': data.httpMethod.toUpperCase() === 'POST',
                    'border-[#fca130] bg-[#fca130]/20': data.httpMethod.toUpperCase() === 'PUT',
                    'border-[#50e3c2] bg-[#50e3c2]/20': data.httpMethod.toUpperCase() === 'PATCH',
                    'border-[#f93e3e] bg-[#f93e3e]/20': data.httpMethod.toUpperCase() === 'DELETE'
                }
            )}
        >
            <span
                className={cn(
                    'inline-flex text-sm items-center justify-center w-1/4 md:w-20 h-7 text-center text-white drop-shadow-[0_1px_0_rgba(0,0,0,.1)] rounded-[3px] font-bold',
                    {
                        'bg-[#61AFFE]': data.httpMethod.toUpperCase() === 'GET',
                        'bg-[#49cc90]': data.httpMethod.toUpperCase() === 'POST',
                        'bg-[#fca130]': data.httpMethod.toUpperCase() === 'PUT',
                        'bg-[#50e3c2]': data.httpMethod.toUpperCase() === 'PATCH',
                        'bg-[#f93e3e]': data.httpMethod.toUpperCase() === 'DELETE'
                    }
                )}
            >
                {data.httpMethod}
            </span>
            <span className="text-primary text-base font-medium break-words w-3/4 md:w-auto">
                {data.path}
            </span>
        </li>
    );
}

function ControllersItem(data) {
    const [itemId, setItemId] = useState(data?.data[0]?.ctrlName);
    const handleShowList = (item) => {
        if (itemId === item.ctrlName) {
            setItemId('');
        } else {
            setItemId(item.ctrlName);
        }
    };
    if (data?.data?.length === 0) {
        return (
            <div className="flex justify-start items-center pl-4">
                <h1 className="text-primary text-2xl font-medium">No data</h1>
            </div>
        );
    }
    return data?.data?.map((item) => (
        <div key={item.ctrlName}>
            <div
                onClick={() => handleShowList(item)}
                role="button"
                tabIndex={-1}
                className="flex justify-between items-center hover:bg-primary-50 text-primary text-xl px-4 py-3 border-b border-b-primary-200 cursor-pointer"
            >
                <h1 className="font-medium text-primary">
                    <span>{item.ctrlName}</span>
                </h1>
                <button type="button">
                    <DownArrowIcon />
                </button>
            </div>
            <ul
                className={cn('h-0 overflow-hidden', {
                    'h-auto': itemId === item.ctrlName
                })}
            >
                {item.data?.map((data2, index) => (
                    <ItemArr key={MD5(data2.path + index)} data={data2} />
                ))}
            </ul>
        </div>
    ));
}
function ApiPageBody({ data }) {
    const { version, baseUrl, endpoints } = data || {};

    const groupedByController = {};
    endpoints?.forEach((obj) => {
        if (!groupedByController[obj.controllerName]) {
            groupedByController[obj.controllerName] = {
                ctrlName: obj.controllerName,
                data: []
            };
        }
        groupedByController[obj.controllerName].data.push({
            httpMethod: obj.httpMethod,
            path: obj.path
        });
    });
    const ControllerAllArr = Object?.values(groupedByController);
    return (
        <div
            className={cn({
                'placeholder-mode': data.demo
            })}
        >
            {/* Body Header and Version */}
            <div className="flex justify-between items-center bg-primary-100 text-primary text-xl px-4 py-3 mb-5 rounded-lg">
                <div>
                    Host URL: <span className="font-medium text-xl">{baseUrl}</span>
                </div>
                <p className="font-medium">
                    <span>{version}</span>
                </p>
            </div>

            {/* Controllers */}
            <ControllersItem data={ControllerAllArr || []} />
        </div>
    );
}

export default ApiPageBody;
